module.exports = `${require.publicPath}certificate-bg2.79d08c82.png`;